import React, { useState, useEffect } from 'react';
import { TextField, IconButton, FormControlLabel, Checkbox } from '@material-ui/core';
import { Create as EditIcon, Visibility as ViewIcon } from '@material-ui/icons';
import moment from 'moment-timezone';

import { formatPbDate, formatCurrency } from '../../../lib/fmt';
import QueryParam from '../../../services/QueryParamService';
import {
  protoTimeSpanObjectToString,
  dateProtoObjectToString,
} from '../../../services/ConvertService';

import {
  listCallLog,
  updateCallLog,
  createCallLog,
  getNewId,
  callNotice,
} from '../../../services/CallLogService';
import { getPreviousDate } from '../../../services/ProfileService';

import AutoCompleteMasterAccountNo from '../../../components/AutoComplete/AutoCompleteMasterAccountNo';
import AutoCompleteCorrespondent from '../../../components/AutoComplete/AutoCompleteCorrespondent';
import AutoCompleteAccountName from '../../../components/AutoComplete/AutoCompleteAccountName';
import {
  SelectMarginType,
  SelectCallType,
} from '../../../components/MultipleSelect/SelectSystemCode';
import SelectSystemCode from '../../../components/Dropdown/SelectSystemCode';
import ClientGrid from '../../../components/ClientGrid/ClientGrid';
import Button from '../../../components/Buttons/Button';
import Text from '../../../components/Typography/Text';
import {
  notifySuccess,
  notifyInfo,
  notifyError,
} from '../../../components/Messages/Notification';
import {
  pbDate,
  pbDateSorter,
  pbDateTime,
  pbDateTimeSorter,
  boolean,
  currency,
} from '../../../components/ClientGrid/CellRenderer';

import CallLogModal from './Components/CallLogModal';
import CallLogAddModal from './Components/CallLogAddModal';
import CallLogDetailsModal from './Components/CallLogDetailsModal';

import Table, {
  columnType,
  tempFilteredRows,
} from '../../../components/ClearingTable/Table';
import { useConfirm } from 'material-ui-confirm';
import useStyles from '../../../styles';
export default function CallLog() {
  const classes = useStyles();
  const confirm = useConfirm();

  const [pagination, setPagination] = useState({});
  const [footerData, setFooterData] = useState({});
  const [totalRows, setTotalRows] = useState(0);

  const isSendNoticeEnabled = (dataIndex) => {
    return tempFilteredRows[dataIndex]?.notify !== true;
  };

  const options = {
    // selectableRows: 'multiple',
    isRowSelectable: (dataIndex) => isSendNoticeEnabled(dataIndex),
    customToolbarSelect: (selectedRows) => {
      return (
        <div
          className={classes.grdRow}
          style={{ margin: 0, padding: 0, marginRight: 20 }}
        >
          <div className={classes.grdCell1}>
            <Button
              disabled={loading.send}
              loading={loading.send}
              color="secondary"
              label={loading.send ? 'Sending...' : 'Send Call Notice'}
              onClick={() => {
                handleCallNotice(
                  selectedRows.data,
                  selectedRows.data.map((d) => d.dataIndex)
                );
              }}
            />
          </div>
        </div>
      );
    },
    serverSide: true,
  };

  const columns = [
    {
      name: '',
      type: columnType.buttons,
      options: {
        customBodyRenderLite: (dataIndex) => {
          return (
            <div
              align={'left'}
              className={classes.grdRow}
              style={{ margin: 0, padding: 0 }}
            >
              <div align={'left'} className={classes.grdCell1}>
                <IconButton
                  aria-label="details"
                  disabled={loading.send || currentSelectedRowsIndex.includes(dataIndex)}
                  onClick={() => {
                    handleOpen(tempFilteredRows[dataIndex]);
                  }}
                >
                  <EditIcon />
                </IconButton>
              </div>
              {/* <div align={'left'} className={classes.grdCell1}>
                <IconButton
                  aria-label="view"
                  onClick={() => handleView(tempFilteredRows[dataIndex])}
                >
                  <ViewIcon />
                </IconButton>
              </div> */}
            </div>
          );
        },
      },
      addFooter: true,
    },
    {
      name: 'tradeDate',
      label: 'Trade Date',
      type: columnType.date,
    },
    {
      name: 'correspondent',
      label: 'Correspondent',
    },
    {
      name: 'masterAccountNo',
      label: 'Master Account No',
    },
    {
      name: 'accountName',
      label: 'Account Name',
    },
    {
      name: 'rep',
      label: 'Rep',
    },
    {
      name: 'marginType',
      label: 'Margin Type',
    },
    {
      name: 'age',
      label: 'Age',
    },
    {
      name: 'callType',
      label: 'Call Type',
    },
    {
      name: 'callReq',
      label: 'Call Requirement',
      type: columnType.amount,
      // addFooter: true,
    },
    {
      name: 'callAmt',
      label: 'Call Amount',
      type: columnType.amount,
      // addFooter: true,
    },
    {
      name: 'origCallAmt',
      label: 'Original Call Amount',
      type: columnType.amount,
    },
    {
      name: 'deposit',
      label: 'Deposit',
      type: columnType.amount,
    },
    {
      name: 'callStatus',
      label: 'Call Status',
    },
    {
      name: 'callStatusReason',
      label: 'Call Status Reason',
    },
    {
      name: 'dueDate',
      label: 'Due Date',
      type: columnType.date,
    },
    {
      name: 'callStatusReasonCount',
      label: 'Call Status Reason Count',
    },
    {
      name: 'notify',
      label: 'Notify',
      type: columnType.bool,
      options: {
        display: false,
      },
    },
    {
      name: 'createdAt',
      label: 'Created At',
      type: columnType.dateTime,
      options: {
        customBodyRenderLite: (dataIndex) => {
          return protoTimeSpanObjectToString(
            tempFilteredRows[dataIndex]?.createdAt,
            'MM/DD/YYYY hh:mm:ss a'
          );
        },
      },
    },
    {
      name: 'createdBy',
      label: 'Created By',
    },
    {
      name: 'modifiedAt',
      label: 'Modified At',
      type: columnType.dateTime,
      options: {
        display: false,
        customBodyRenderLite: (dataIndex) => {
          return protoTimeSpanObjectToString(
            tempFilteredRows[dataIndex]?.modifiedAt,
            'MM/DD/YYYY hh:mm:ss a'
          );
        },
      },
    },
    {
      name: 'modifiedBy',
      label: 'Modified By',
      type: columnType.text,
      options: {
        display: false,
      },
    },
    {
      name: 'notifyDate',
      label: 'Notify Date',
      type: columnType.dateTime,
      options: {
        display: false,
        customBodyRenderLite: (dataIndex) => {
          return protoTimeSpanObjectToString(
            tempFilteredRows[dataIndex]?.notifyDate,
            'MM/DD/YYYY hh:mm:ss a'
          );
        },
      },
    },
  ];

  const [rowData, setRowData] = React.useState({});
  const [open, setOpen] = React.useState(false);
  const [openAdd, setOpenAdd] = React.useState(false);
  const [loading, setLoading] = React.useState({
    search: false,
    save: false,
    send: false,
  });
  const [currentSelectedRowsIndex, setCurrentSelectedRowsIndex] = React.useState([]);
  const [showFilter, setShowFilter] = React.useState(true);
  const [rows, setRows] = useState([]);
  const [searchData, setSearchData] = React.useState(
    QueryParam.get({
      fromDate: '',
      toDate: '',
      correspondent: '',
      masterAccountNo: '',
      accountName: '',
      callStatus: 'Pending',
      callStatusReason: '',
      isOpen: false,
      search: false,
    })
  );

  const getCsvData = async () => {
    if (totalRows === 0) {
      return [];
    }
    const MAX_RECORDS_ALLOWED = 100000;

    let paginationCopy = {
      ...pagination,
      reload: false,
      pageNo: 0,
      rowsPerPage: MAX_RECORDS_ALLOWED,
    };

    const data = await listCallLog(searchData, paginationCopy);

    if (data.callLogsList.length >= MAX_RECORDS_ALLOWED) {
      confirm({
        description:
          'Only ' +
          MAX_RECORDS_ALLOWED.toLocaleString() +
          ' items will be downloaded, if you need more please use the metabase.',
        confirmationText: 'I understand',
      });
    }

    const csvData = data.callLogsList.map((item) => {
      let tempDate = formatPbDate(item.satisfiedDate);
      item.satisfiedDate = tempDate;
      return item;
    });

    return csvData;
  };

  const handleChange = (e, checkboxValue) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;

    setSearchData({
      ...searchData,
      [input.name]:
        checkboxValue === true || checkboxValue === false ? checkboxValue : input.value,
    });
  };

  const handleSearch = async (paginationChange, fromCall) => {
    try {
      setLoading({ ...loading, search: true });
      QueryParam.set(searchData);

      let paginationCopy = {
        ...pagination,
        reload: false,
        pageNo: paginationChange === true ? pagination.pageNo : 0,
        rowsPerPage: pagination.rowsPerPage || 100,
      };

      const data = await listCallLog(searchData, paginationCopy);
      setTotalRows(data.summary.totalRows);

      paginationCopy.count = data.summary.totalRows;
      setPagination(paginationCopy);
      setRows(data.callLogsList);

      setFooterData({
        callReq: formatCurrency(data.summary.callReq),
        callAmt: formatCurrency(data.summary.callAmt),
      });
      if (paginationChange !== true || fromCall) {
        notifyInfo(data.summary.totalRows + ' search results.');
      }
    } catch (error) {
      console.error(error);
      setLoading({ ...loading, search: false });
      notifyError(error.message);
    } finally {
      setLoading({ ...loading, search: false });
    }
  };

  const handleCallNotice = async (selected, index) => {
    let idsToTransfer = [];

    for (const s of selected) {
      idsToTransfer.push(tempFilteredRows[s.dataIndex]?.requirementLogId);
    }

    try {
      setCurrentSelectedRowsIndex(index);
      setLoading({ ...loading, send: true });
      await callNotice(idsToTransfer);
      setCurrentSelectedRowsIndex([]);
      setLoading({ ...loading, send: false });
      notifyInfo('Successfully sent a notice.');
      handleSearch();
    } catch (error) {
      setCurrentSelectedRowsIndex([]);
      setLoading({ ...loading, send: false });
      notifyError(error.message);
    }
  };

  const handleOpenAdd = async (data) => {
    if (!data) {
      data = {
        requirementLogId: 0,
      };
      await getNewId().then((res) => {
        data.requirementLogId = res.requirementLogId;
      });
      setRowData(data);
      setOpenAdd(true);
    }
  };

  const handleOpen = (data) => {
    let dataCopy = { ...data };
    if (data.dueDate) {
      dataCopy.dueDate = dateProtoObjectToString(data.dueDate);
    }

    if (data.satisfiedDate) {
      dataCopy.satisfiedDate = dateProtoObjectToString(data.satisfiedDate);
    }

    if (data.tradeDate) {
      dataCopy.tradeDate = dateProtoObjectToString(data.tradeDate);
    }

    setRowData(dataCopy);
    setOpen(true);
  };

  const handleClose = async (data, closeOnly, noteList) => {
    if (closeOnly) {
      setOpen(false);
      return;
    }

    if (!data) {
      setOpen(false);
      return;
    }

    try {
      let valid = true;

      if (data.tradeDate > data.dueDate) {
        notifyError('Due Date should be greater than Trade Date.');
        valid = false;
      }

      if (noteList.length === 0) {
        notifyError('Note is required.');
        valid = false;
      }

      if (!data.callStatus) {
        notifyError('Call Status is required.');
        valid = false;
      }
      if (data.callStatus === 'Satisfied' && !data.callStatusReason) {
        notifyError('Call Status Reason is required.');
        valid = false;
      }

      if (!data.callAmt) {
        notifyError('Call Amount is required.');
        valid = false;
      }
      if (!data.dueDate) {
        notifyError('Due Date is required.');
        valid = false;
      }

      if (!valid) {
        return;
      }

      setLoading({ ...loading, save: true });
      const resp = await updateCallLog(data);
      const rowsCopy = [...rows];
      const index = rows.indexOf(rowData);
      rowsCopy[index] = resp.callLog;
      setRows(rowsCopy);
      setLoading({ ...loading, send: false });
      notifySuccess('Call log has been updated.');

      setOpen(false);
      handleSearch(true);
    } catch (error) {
      console.error(error);
      setLoading({ ...loading, send: false });
      notifyError(error.message);
    }
  };

  const handleCloseAdd = async (data, closeOnly, noteList) => {
    if (closeOnly) {
      setOpenAdd(false);
      //await deleteRecord('margin.call_log', 'requirement_log_id', data.requirementLogId);
      return;
    }

    try {
      let valid = true;

      if (!data.accountId || data.accountId === 0) {
        notifyError(
          'No client account found with master account no ' +
            data.masterAccountNo +
            ' margin type ' +
            data.marginType +
            '.'
        );
        valid = false;
      }
      if (data.accountId || data.accountId !== 0) {
        if (noteList.length === 0) {
          notifyError('Note is required.');
          valid = false;
        }
      }

      if (!data.age) {
        notifyError('Age is required.');
        valid = false;
      }

      if (!data.dueDate) {
        notifyError('Due Date is required.');
        valid = false;
      }

      if (!data.origCallAmt) {
        notifyError('Original Call Amount is required.');
        valid = false;
      }

      if (!data.callAmt) {
        notifyError('Call Amount is required.');
        valid = false;
      }

      if (!data.callReq) {
        notifyError('Call Requirement is required.');
        valid = false;
      }

      if (data.callStatus === 'Satisfied' && !data.callStatusReason) {
        notifyError('Call Status Reason is required.');
        valid = false;
      }
      if (!data.callStatus) {
        notifyError('Call Status is required.');
        valid = false;
      }

      if (!data.callType) {
        notifyError('Call Type is required.');
        valid = false;
      }

      if (!data.marginType) {
        notifyError('Margin Type is required.');
        valid = false;
      }

      if (!data.masterAccountNo) {
        notifyError('Master Account No is required.');
        valid = false;
      }

      if (!data.correspondent) {
        notifyError('Correspondent is required.');
        valid = false;
      }

      if (data.tradeDate > data.dueDate) {
        notifyError('Trade Date should not be greater than Due Date.');
        valid = false;
      }
      if (!data.tradeDate) {
        notifyError('Trade Date is required.');
        valid = false;
      }

      if (!valid) {
        return;
      }

      setLoading({ ...loading, save: true });

      const resp = await createCallLog(data);
      setRows([resp.callLog, ...rows]);
      setLoading({ ...loading, send: false });
      notifySuccess('Call log has been created.');
      setOpenAdd(false);
    } catch (error) {
      console.error(error);
      setLoading({ ...loading, send: false });
      notifyError(error.message);
    }
  };

  // const handleView = async (data) => {
  //   const date = moment(new Date(formatPbDate(data.tradeDate))).format('yyyy-MM-DD');

  //   let urlParam;
  //   let paramPath;

  //   if (data.callType === 'Min Balance') {
  //     urlParam = QueryParam.jsonToQueryString({
  //       fromDate: date,
  //       toDate: date,
  //       masterAccountNo: data.masterAccountNo,
  //       search: true,
  //     });

  //     paramPath = await navigateToDynamicPath('Balance', urlParam);
  //   } else if (data.callType === 'Buying Power') {
  //     urlParam = QueryParam.jsonToQueryString({
  //       fromDate: date,
  //       toDate: date,
  //       masterAccountNo: data.masterAccountNo,
  //       search: true,
  //     });

  //     paramPath = await navigateToDynamicPath('TimeAndTick', urlParam);
  //   } else if (data.callType === 'Free Riding') {
  //     paramPath = '/cash-call-log/cash-call-details/' + date + '/' + data.masterAccountNo;
  //   } else {
  //     paramPath =
  //       '/margin-interest/margin-requirement-details/' +
  //       date +
  //       '/' +
  //       data.masterAccountNo;
  //   }

  //   window.open(paramPath, '_blank');
  // };

  useEffect(
    () => {
      async function init() {
        if (searchData.toDate || searchData.fromDate) return;

        const systemDate = await getPreviousDate();

        setSearchData({
          ...searchData,
          toDate: systemDate,
          fromDate: systemDate,
        });
      }

      init();

      if (searchData.search) {
        handleSearch();
      }
    },
    // eslint-disable-next-line
    []
  );

  return (
    <form className="page-c">
      <div className="search-c">
        <div className="grd-row nm">
          <div className="grd-cell">
            <Text mt={8} variant="h1" label="Call Log" />
          </div>
          <div className="grd-cell-none">
            <Button
              disabled={loading.search}
              loading={loading.search}
              type="search"
              label={loading.search ? 'Searching...' : 'Search'}
              onClick={handleSearch}
            />
          </div>
          <div className="grd-cell-none">
            <Button
              type="plus"
              label="Add New"
              onClick={() => {
                handleOpenAdd();
              }}
            />
          </div>
          {/* {callNoticeAccess && (
            <div className="grd-cell-none">
              <Button
                disabled={selectedRowsIds.length ? loading.save : true}
                label="SEND CALL NOTICE"
                onClick={() => {
                  handleCallNotice(selectedRowsIds, selectedRowsIds);
                }}
              />
            </div>
          )} */}
        </div>
        <div className="grd-row">
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <TextField
              disabled={searchData.isOpen}
              name="fromDate"
              fullWidth
              label="From Date"
              type="date"
              value={searchData.fromDate}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              inputProps={{ max: searchData.toDate }}
            />
          </div>
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <TextField
              disabled={searchData.isOpen}
              name="toDate"
              fullWidth
              label="To Date"
              type="date"
              value={searchData.toDate}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              inputProps={{ min: searchData.fromDate }}
            />
          </div>
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <SelectCallType
              name="callType"
              label="Call Type"
              value={searchData.callType}
              onChange={handleChange}
              onKeyDown={(e) => (e.keyCode === 13 ? handleSearch() : null)}
            ></SelectCallType>
          </div>
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <SelectSystemCode
              name="callStatus"
              label="Call Status"
              type="Status"
              subType="Call Status"
              value={searchData.callStatus}
              onChange={handleChange}
            ></SelectSystemCode>
          </div>
          <div className="grd-cell">
            <SelectSystemCode
              name="callStatusReason"
              label="Call Status Reason"
              type="Status"
              subType="Call Status Reason"
              value={searchData.callStatusReason}
              onChange={handleChange}
            ></SelectSystemCode>
          </div>
        </div>
        <div className="grd-row">
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <AutoCompleteCorrespondent
              name="correspondent"
              freeSolo={true}
              value={searchData.correspondent}
              isAccessibleOnly={true}
              onChange={handleChange}
            ></AutoCompleteCorrespondent>
          </div>
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <AutoCompleteAccountName
              label="Account Name"
              name="accountName"
              value={searchData.accountName}
              correspondent={searchData.correspondent}
              isAccessibleOnly={true}
              freeSolo={true}
              onChange={handleChange}
            ></AutoCompleteAccountName>
          </div>
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <AutoCompleteMasterAccountNo
              name="masterAccountNo"
              label="Master Account No"
              freeSolo={true}
              value={searchData.masterAccountNo}
              correspondent={searchData.correspondent}
              isAccessibleOnly={true}
              onChange={handleChange}
            ></AutoCompleteMasterAccountNo>
          </div>
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <SelectMarginType
              name="marginType"
              label="Margin Type"
              value={searchData.marginType}
              onChange={handleChange}
              onKeyDown={(e) => (e.keyCode === 13 ? handleSearch() : null)}
            ></SelectMarginType>
          </div>
          <div className="grd-cell">
            <FormControlLabel
              control={
                <Checkbox
                  name="isOpen"
                  checked={searchData.isOpen}
                  onChange={handleChange}
                />
              }
              label="Open"
            />
          </div>
        </div>
      </div>

      <div className="mt-20">
        <Table
          title={'Call Log'}
          data={rows}
          columns={columns}
          options={options}
          onSearch={handleSearch}
          pagination={pagination}
          setPagination={setPagination}
          getCsvData={getCsvData}
          footerData={footerData}
          additionalCell={true}
        />
      </div>
      {open && (
        <CallLogModal
          onClose={handleClose}
          open={open}
          value={rowData}
          loading={loading.save}
        ></CallLogModal>
      )}
      {openAdd && (
        <CallLogAddModal
          onClose={handleCloseAdd}
          open={openAdd}
          value={rowData}
          loading={loading.save}
        ></CallLogAddModal>
      )}
      {/* {openDetails && (
        <CallLogDetailsModal
          onClose={() => setOpenDetails(false)}
          open={openDetails}
          value={rowData}
        ></CallLogDetailsModal>
      )} */}
    </form>
  );
}
